"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListBullets = void 0;
const react_1 = __importDefault(require("react"));
const ListBullets = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 52 52", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { stroke: color || '#25CFBB' },
            react_1.default.createElement("path", { d: "M-6.712 52.536v-63.75h63.75v63.75h-63.75Z", strokeWidth: ".25" }),
            react_1.default.createElement("path", { d: "M15.163 9h32M15.165 25h31.998M15.165 42.661h31.998", strokeWidth: "4", strokeLinecap: "round", strokeLinejoin: "round" }),
            react_1.default.createElement("path", { d: "M7.039 9a2.875 2.875 0 1 1-5.75 0 2.875 2.875 0 0 1 5.75 0ZM7.038 25a2.875 2.875 0 1 1-5.75 0 2.875 2.875 0 0 1 5.75 0ZM7.038 42.661a2.875 2.875 0 1 1-5.75 0 2.875 2.875 0 0 1 5.75 0Z", fill: color || '#25CFBB', strokeWidth: ".25" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "a" },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 0h50v50H0z" })))));
};
exports.ListBullets = ListBullets;
